import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { WhatsAppFab } from "./components/WhatsAppFab";
import { AuthProvider, useAuth } from "./lib/auth";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import { ForgotPassword, ResetPassword } from "./pages/PasswordReset";
import Admin from "./pages/Admin";
import SchoolApp from "./pages/SchoolApp";
import Invite from "./pages/Invite";

function Guard({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-500">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role === "super" && user.platform_role !== "super_admin") return <Navigate to="/app" replace />;
  if (role === "school" && user.platform_role === "super_admin" && !localStorage.getItem("mapia_school")) return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/esqueci-senha" element={<ForgotPassword />} />
          <Route path="/redefinir-senha" element={<ResetPassword />} />
          <Route path="/convite/:token" element={<Invite />} />
          <Route path="/admin" element={<Guard role="super"><Admin /></Guard>} />
          <Route path="/app" element={<Guard role="school"><SchoolApp /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="bottom-left" />
      <WhatsAppFab />
    </AuthProvider>
  );
}

export default App;
